import { cssVars } from '@/app/styles';
import { Charts } from '@/chart/chart';
import { LineChartOptions } from '@/chart/chart-options';
import { DEFAULT_CHART_BASE_TYPE } from '@/chart/components/all-charts-styles';
import { DisplayMinMaxValuePlugin } from '@/chart/plugins/display-min-max-value-plugin';
import { datasetTypes } from '@/constants';
import {
  SingleValueDataBuilder,
  constructDatasets,
} from '@/utils/chart-data-builder';
import { numberStartsWithDollarSign } from '@/utils/string-utils';

export class RevenueDataBuilder extends SingleValueDataBuilder {
  constructor(data, chartMode = null, dataType = 'revenue') {
    super(data, dataType);
    this.datasets = [];
    this.chartMode = chartMode;
    this.datasetConfigurations = RevenueDataBuilder.configurations;
  }

  static get configurations() {
    return [
      {
        fill: false,
        borderColor: cssVars.chartColors.revenueAccent,
        backgroundColor: cssVars.chartColors.revenueAccent,
        pointBackgroundColor: cssVars.chartColors.revenueAccent,
        pointRadius: 2,
        pointHoverRadius: 4,
        borderWidth: 2,
      },
    ];
  }

  get retrieveDatasets() {
    return constructDatasets(
      this.labels,
      this.data,
      'line',
      this.datasetConfigurations
    );
  }
}

class RevenueChart extends Charts {
  static pluginParams = {
    pluginTextColor: cssVars.chartColors.revenueAccent,
    pluginFormatter: numberStartsWithDollarSign,
    pluginAlignment: 'top',
  };

  static tooltipParams = {
    unit: '$',
  };

  static getParams() {
    return {
      pluginParams: this.pluginParams,
      tooltipParams: this.tooltipParams,
    };
  }

  static getOptions(props) {
    return {
      ...RevenueChart.getParams(),
      ...props,
    };
  }

  constructor(props) {
    super({
      DataBuilder: RevenueDataBuilder,
      chartProps: props,
      name: datasetTypes.REVENUE,
      options: new LineChartOptions(RevenueChart.getOptions(props))
        .chartOptions,
      baseType: DEFAULT_CHART_BASE_TYPE,
      plugins: [DisplayMinMaxValuePlugin()],
    });
  }
}

const chart = (props) => new RevenueChart(props).chart;

export default chart;
